export interface User {
  userId: number;
  email: string;
}

const TOKEN_KEY = "oe_token";

/** Exchange a Hanko session token for an app JWT. */
export async function loginWithHanko(hankoToken: string): Promise<User | null> {
  try {
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: hankoToken }),
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { token: string; userId: number; email: string };
    if (typeof window !== "undefined") {
      localStorage.setItem(TOKEN_KEY, data.token);
    }
    return { userId: data.userId, email: data.email };
  } catch {
    return null;
  }
}

export function logout(): void {
  if (typeof window !== "undefined") {
    localStorage.removeItem(TOKEN_KEY);
    fetch("/api/auth/logout", { method: "POST" }).catch(() => {});
  }
}

export function getToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser(): User | null {
  const token = getToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1])) as {
      userId: number;
      email: string;
      exp?: number;
    };
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      logout();
      return null;
    }
    return { userId: payload.userId, email: payload.email };
  } catch {
    logout();
    return null;
  }
}

/** Returns Authorization header object for fetch calls, or empty object if not logged in. */
export function authHeaders(): Record<string, string> {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
